<template>
  <BackTop :height="100" :bottom="200">
      <div class="top">返回顶端</div>
  </BackTop>
</template>

<script>
export default {

}
</script>

<style scoped lang="less">
.top{
    padding: 10px;
    background: @common;
    color: @font-white;
    text-align: center;
    border-radius: 2px;
}
</style>
